module.exports = __webpack_public_path__ + "static/media/gryphon-house-bedroom-window-view.6b52afa1.jpg";